module.exports = "/fonts/vendor/boxicons/boxicons.svg?b0bb967778275b356010f01219188eb0";